// extracted by mini-css-extract-plugin
module.exports = {"lane":"styles_lane__WJPqd","textLeft":"styles_textLeft__pcJTM","stackedText":"styles_stackedText__F__00","textRight":"styles_textRight___jWWu","text":"styles_text__BYR7F"};